import { TEstimationSectionSchema } from "@/schemas/project-register.schema";

export const ESTIMATE_CONST = {
  MESSAGES: {
    USE_REVIEW_SHEET:
      "useReviewSheet must be used within a ReviewSheetProvider",
    ADD_NOTE_SECTION:
      "Add some notes that's related to the corresponding section.",
    ADD_ITEM: "Please add at least one item to the estimation.",
    ES_SAVED: "Estimation saved successfully.",
    ES_SAVED_REVISION: "Estimation saved as revision successfully.",
    ES_DELETED: "Estimation deleted successfully.",
    ES_UPDATED: "Estimation updated successfully.",
    ES_FINAL_NO_UPDATE: "You can't update follow up for final estimate.",
    ES_REVIEWED: "Estimation reviewed successfully.",
    ES_REVIEW_SAVED: "Estimation review saved successfully.",
    FOLLOWUP_UPDATED: "Follow up updated successfully.",
    ES_TABLE_UPDATED: "Estimation table updated.",
    // MOVE_TRASH_PROGRESS: "Move to trash in progress.",
  },
  BUTTONS: {
    RESET: "Reset",
    SAVE_NOTES: "Save Notes",
    ADD_OPTIONAL_COST: "Add Optional Cost",
    OPTIONAL_COST: "Optional Cost",
  },
  ES_FILTERS_KEYS: [
    "dateRange",
    "statusId",
    "addedBy",
    "followUp",
    "customerId",
    "prospectId",
    "search",
    "limit",
    "offset",
    "currentPage",
    "sortBy",
    "orderBy",
  ],
};

export const defaultEstimationItem: TEstimationSectionSchema = {
  name: "",
  total: 0,
  note: "",
  position: 0,
  details: [],
};
